import {useMemo} from 'react';

import {ANNOTATOR_PORTAL_ROOT_ID, PORTAL_ROOT_ID} from '~constants/constants';
import {selectIsFullscreen} from '~redux/reducers/annotatorReducer';
import {useAppSelector} from '~redux/index';

export function useAnnotatorPortalRoot(): HTMLElement {
  const isFullscreen = useAppSelector(selectIsFullscreen);

  return useMemo(() => {
    if (isFullscreen) {
      const annotatorPortal = document.fullscreenElement?.querySelector(`#${ANNOTATOR_PORTAL_ROOT_ID}`);
      if (annotatorPortal instanceof HTMLElement) {
        return annotatorPortal;
      }
    }

    return document.getElementById(PORTAL_ROOT_ID) ?? document.body;
  }, [isFullscreen]);
}
